import { MdOutlineEdit } from "react-icons/md";
import styled from "styled-components";
import tw from "twin.macro";
import { useComment, useCommentValue } from "..";
import { usePost } from "../../..";
import EditButtonC from "../../../../../components/EditButtonC";

type Props = {};

const EditButton = (props: Props) => {
  const { set: setCommentContext } = useComment();
  const { set: setPostContext } = usePost();
  const commentText = useCommentValue((s) => s.comment.text);
  const commentId = useCommentValue((s) => s.comment._id);

  const handleSetEditing = () => {
    setCommentContext({ isEditing: true, editingText: commentText });
    setPostContext({ currentEditingCommentId: commentId });
  };

  return (
    <EditButtonC onClick={handleSetEditing} />
  );
};


export default EditButton;
